import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class PatientService {
  private patientSubject: BehaviorSubject<any>;
  public patient$: Observable<any>;

  constructor(private router: Router, private http: HttpClient) {
    this.patientSubject = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem('patient'))
    );
    this.patient$ = this.patientSubject.asObservable();
  }

  public get patientInfo(): any {
    return this.patientSubject.value;
  }

  send_otp(info: any) {
    return this.http
      .post<any>(`${environment.apiUrl}patients/send-otp`, info)
      .pipe(
        map((info) => {
          return info;
        })
      );
  }

  verify_otp(info: any) {
    return this.http
      .post<any>(`${environment.apiUrl}patients/verify-otp`, info)
      .pipe(
        map((patient) => {
          localStorage.setItem('patient', JSON.stringify(patient));
          this.patientSubject.next(patient);
          return patient;
        })
      );
  }

  register(patient: any) {
    return this.http.post(
      `${environment.apiUrl}patients/pre-register`,
      patient
    );
  }

  setPatientInfo(patient: any) {
    localStorage.setItem('patient', JSON.stringify(patient));
    this.patientSubject.next(patient);
  }

  logout() {
    localStorage.removeItem('patient');
    this.patientSubject.next(null);
    localStorage.removeItem('cartItems');
    this.router.navigate(['/account/login']);
  }

  getPatientInfo(id: string, mobile: string) {
    return this.http.get<any>(
      `${environment.apiUrl}patients/portal_info/${mobile}/${id}/true`
    );
  }
  downloadVisitSummary(patient: any) {
    return this.http.get<any>(
      `${environment.apiUrl}patients/portal_visits_summary/${patient.encounter_id}/${patient.department_id}/${patient.doctor_id}`
    );
  }
  downloadBillSummary(patient: any) {
    return this.http.get<any>(
      `${environment.apiUrl}patients/portal_bills_summary/${patient.encounter_id}`
    );
  }
  downloadPharmacyBillSummary(patient: any) {
    return this.http.get<any>(
      `${environment.apiUrl}patients/portal_pharmacy_bills_summary/${patient.UHID}`
    );
  }
  downloadLabSummary(patient: any) {
    return this.http.get<any>(
      `${environment.apiUrl}patients/lab_report/${patient.encounter_id}`
    );
  }
  downloadRadiologySummary(patient: any) {
    return this.http.get<any>(
      `${environment.apiUrl}patients/radiology_report/${patient.encounter_id}`
    );
  }
}
